"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalVideoPlayer = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouter = require("react-router");

var _reactRedux = require("react-redux");

var _ = require("../../");

var _VideoPlayer = require("../../organisms/VideoPlayer");

var _getTrackingCategory = require("../../util/getTrackingCategory");

var _excluded = ["moments", "momentId", "containerRef", "trackingCategory", "trackingAction", "previewMode", "disabledControls"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ModalVideoPlayer = function ModalVideoPlayer(_ref) {
  var moments = _ref.moments,
      momentId = _ref.momentId,
      containerRef = _ref.containerRef,
      trackingCategory = _ref.trackingCategory,
      trackingAction = _ref.trackingAction,
      _ref$previewMode = _ref.previewMode,
      previewMode = _ref$previewMode === void 0 ? false : _ref$previewMode,
      disabledControls = _ref.disabledControls,
      props = _objectWithoutProperties(_ref, _excluded);

  var history = (0, _reactRouter.useHistory)();
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useVideoControls = (0, _VideoPlayer.useVideoControls)(containerRef),
      play = _useVideoControls.play,
      pause = _useVideoControls.pause;

  var _useMetaVideoInfo = (0, _VideoPlayer.useMetaVideoInfo)(containerRef),
      paused = _useMetaVideoInfo.paused;

  var _usePlaylistControls = (0, _VideoPlayer.usePlaylistControls)(containerRef),
      onNext = _usePlaylistControls.onNext,
      onPrev = _usePlaylistControls.onPrev,
      goToNext = _usePlaylistControls.goToNext,
      goToPrev = _usePlaylistControls.goToPrev,
      setItems = _usePlaylistControls.setItems;

  var toast = function toast(show, msg) {
    return function (dispatch) {
      dispatch({
        type: 'TOAST',
        show: show,
        msg: msg
      });
    };
  };

  (0, _react.useEffect)(function () {
    var id = momentId;

    if (!id && moments.length > 0) {
      id = moments[0].game_clip_id;
    }

    setItems(moments, id); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [moments, containerRef === null || containerRef === void 0 ? void 0 : containerRef.current]); //// Handlers
  // Moment navigation

  onNext(function (moment) {
    if (!previewMode) {
      var parts = history.location.pathname.split("/");
      parts[parts.length - 1] = moment.game_clip_id;
      history.push(parts.join("/"));
    }
  });
  onPrev(function (moment) {
    if (!previewMode) {
      var parts = history.location.pathname.split("/");
      parts[parts.length - 1] = moment.game_clip_id;
      history.push(parts.join("/"));
    }
  });
  (0, _VideoPlayer.useVideoOnEnded)(function () {
    goToNext();
  }); //// Video Keyboard Shortcuts
  // Play/Play via Spacebar

  (0, _.useHotKeyHandler)([" "], function () {
    if (paused) {
      dispatch(toast(true, "Play"));
      play();
    } else {
      dispatch(toast(true, "Pause"));
      pause();
    }
  }, {
    preventDefault: true
  }); // Next

  (0, _.useHotKeyHandler)(["Enter"], function () {
    dispatch(toast(true, "Next"));
    goToNext();
  }); // ArrowRight

  (0, _.useHotKeyHandler)(["ArrowRight"], function () {
    dispatch(toast(true, "Next"));
    goToNext();
  }); // ArrowRight

  (0, _.useHotKeyHandler)(["ArrowLeft"], function () {
    dispatch(toast(true, "Previous"));
    goToPrev();
  });
  return /*#__PURE__*/_react.default.createElement(_VideoPlayer.VideoContainer, _extends({}, props, {
    containerRef: containerRef,
    videoSettingsKey: "trace_id",
    radar: true,
    noMulticam: true,
    trackingPlaylistType: "user_playlists",
    trackingCategory: (0, _getTrackingCategory.getTrackingCategory)(),
    trackingAction: trackingAction,
    trackingPlayerType: "Modal",
    fullScreenElementSelector: ".MyMomentPlayer .VideoContainer .VideoPlayer",
    disabledControls: disabledControls
  }));
};

exports.ModalVideoPlayer = ModalVideoPlayer;